<template>
	<ViewFeedItem class="view-feed-contenteventflyer">
		<template v-slot:header>
			<ViewLayoutModuleHeader v-bind:subtitle="subtitle" v-bind:title="title">
				<!-- <RouterLink v-bind:to="{ name: 'PagePlaces' }">
					<strong>View All</strong>
				</RouterLink> -->
			</ViewLayoutModuleHeader>
		</template>

		<template v-slot:body>
			<ChalkyMediaFeed
				class="chalky media-user"
				v-bind:key="contentCollection.uniqueKey"
				v-bind:mediaCollection="mediaCollection"
			></ChalkyMediaFeed>
		</template>
	</ViewFeedItem>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, created, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Feed
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewFeedContentEventFlyer extends ViewBase {
		/**
		 * @return string
		 */
		protected get subtitle(): string {
			return `Discover upcoming events in cue sports.`;
		}

		/**
		 * @return string
		 */
		protected get title(): string {
			return `Get in on the action`;
		}

		/**
		 * @type string
		 */
		protected get iconUrl(): string {
			return this.contentModel.getIconUrl() || 'https://www.chalkysticks.com/favicon.png';
		}

		/**
		 * @return ChalkySticks.Collection.Content
		 */
		public contentCollection: ChalkySticks.Collection.Content = new ChalkySticks.Collection.Content();

		/**
		 * @return ChalkySticks.Model.Content
		 */
		protected contentModel: ChalkySticks.Model.Content = ChalkySticks.Factory.Content.model();

		/**
		 * @return ChalkySticks.Collection.Media
		 */
		protected mediaCollection: ChalkySticks.Collection.Media = new ChalkySticks.Collection.Media();

		/**
		 * @return ChalkySticks.Model.Media
		 */
		protected mediaModel: ChalkySticks.Model.Media = new ChalkySticks.Model.Media();

		/**
		 * @return Promise<void>
		 */
		@created
		public async afterCreate(): Promise<void> {
			await this.contentCollection.tags(['event', 'flyer']).fetch();

			// Get the first item
			this.contentModel = this.contentCollection.shuffle().first();

			// Set the media model
			this.mediaModel.set({
				type: 'image',
				url: this.contentModel.getMediaUrl(),
			});

			this.mediaCollection.add(this.mediaModel);
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @return Promise<void>
		 */
		protected async Handle_OnClickRefresh(): Promise<void> {
			this.contentModel = this.contentCollection.shuffle().first();
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-feed-contenteventflyer {
		.body {
			padding: var(--padding);
			padding-top: 0;

			.paused-container {
				display: none;
			}
		}
	}
</style>
